module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-03-d9db10e9e3fcedc30d560632fcd27c1b.svg";